export default "/catalog/_next/static/scripts/shadydom.min.bd8c9ac099591fdac2a3af646ccc5cc7.js";